<template>
    <div>
        <div
            style="position: -webkit-sticky; position: sticky; top: 48px; background-color:white; z-index:1;"
        >
            <div class="d-flex align-center">
                <v-text-field
                    v-model.trim="searchQuery"
                    label="Szukaj"
                    prepend-inner-icon="mdi-magnify"
                    maxlength="100"
                    clearable
                ></v-text-field>

                <v-spacer></v-spacer>

                <span class="body-2 text--secondary d-none d-sm-inline">{{ from }}-{{ to }} z {{ total }}</span>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" :disabled="isPageFirst" @click="prevPage">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                    </template>
                    <span>Poprzednia strona</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" :disabled="isPageLast" @click="nextPage">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </template>
                    <span>Następna strona</span>
                </v-tooltip>
            </div>
            <hr class="mb-1">
        </div>

        <loading-message v-if="systemIndexing" :message="loadingMessage" class="my-5"></loading-message>
        <v-simple-table v-else-if="systems.length" style="table-layout: auto">
            <template v-slot:default>
                <tbody>
                <tr
                    v-for="system in systems"
                    :key="system.SystemID"
                >
                    <th class="text-no-wrap">{{ system.SystemName }}</th>
                    <td style="width: 100%;">{{ system.Comments }}</td>
                    <td class="text-center text-no-wrap">
                        <client-system-chip
                            v-for="client in system.Clients"
                            :client="client"
                            :key="client.ClientSystem.ClientSystemID"
                            @clientSystemDestroyed="systemIndex"
                        />
                        <v-chip
                            v-if="!system.Clients.length"
                            class="ma-2"
                            color="green"
                            text-color="white"
                            small
                        >
                            Dostęp nieograniczony
                        </v-chip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    elevation="2"
                                    icon
                                    raised
                                    x-small
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="showSystemAssignClientDialog(system)
                                ">
                                    <v-icon>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Przypisz klienta do systemu {{ system.SystemName }}</span>
                        </v-tooltip>
                    </td>
                    <td class="text-center text-no-wrap">
                        <img
                            v-if="system.SystemImage"
                            :src="system.SystemImage"
                            :alt="system.SystemName"
                            style="height:75px;"
                            class="my-3"
                        />
                        <span v-else class="font-italic">- brak zdjęcia -</span>
                    </td>
                    <td class="text-right">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-if="system.SystemImage" v-bind="attrs" v-on="on" icon @click="showSystemImageDeleteDialog(system)">
                                    <v-icon>mdi-trash-can-outline</v-icon>
                                </v-btn>
                                <v-btn v-else v-bind="attrs" v-on="on" icon @click="showSystemImageStoreDialog(system)">
                                    <v-icon>mdi-plus-circle-outline</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="system.SystemImage">Usuń zdjęcie</span>
                            <span v-else>Dodaj zdjęcie</span>
                        </v-tooltip>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-alert
            v-else
            border="left"
            colored-border
            type="info"
            elevation="1"
        >{{ emptyMessage }}</v-alert>

        <v-dialog
            v-model="systemImageStoreDialog"
            persistent
            width="500"
        >
            <v-card v-if="systemToStoreSystemImage">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Zdjęcie systemu {{systemToStoreSystemImage.SystemName}}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideSystemImageStoreDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-file-input
                        v-model="systemImageForm.SystemImage"
                        label="Zdjęcie systemu"
                        hint="Dozwolone formaty: jpg, png, tif. Maksymalny rozmiar: 5Mb."
                        persistent-hint
                        prepend-icon="mdi-camera"
                        :error="$store.getters.hasValidationError('SystemImage')"
                        :error-messages="$store.getters.validationError('SystemImage')"
                    ></v-file-input>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="systemImageStore"
                        :loading="systemImageStoring"
                    >Dodaj</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="systemImageDeleteDialog"
            persistent
            width="500"
        >
            <v-card v-if="systemToDeleteSystemImage">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Usuwanie zdjęcia
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideSystemImageDeleteDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    Czy na pewno chcesz usunąć zdjęcie systemu
                    <strong>{{systemToDeleteSystemImage.SystemName}}</strong>?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        rounded
                        @click="systemImageDelete(systemToDeleteSystemImage)"
                        :loading="systemImageDeleting"
                    >Usuń</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="systemAssignClientDialog"
            persistent
            width="500"
        >
            <v-card v-if="systemToAssignClient">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Przypisz system do klienta
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideSystemAssignClientDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-autocomplete
                        solo
                        hide-no-data
                        v-model="clientID"
                        :items="clients"
                        :search-input.sync="clientSearch"
                        label="Wyszukaj użytkownika"
                        :loading="clientIndexing"
                        item-text="ClientName"
                        item-value="ClientID"
                        :error="$store.getters.hasValidationError('ClientID')"
                        :error-messages="$store.getters.validationError('ClientID')"
                    ></v-autocomplete>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="clientStore"
                        :loading="clientStoring"
                    >Dodaj</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingMessage from "../../../components/LoadingMessage";
import ClientSystemChip from "../../../components/ClientSystemChip.vue";

export default {
    name: "Systems",
    components: {
        ClientSystemChip,
        LoadingMessage,
    },
    data() {
        return {
            searchQuery: "",

            systemIndexing: false,
            systems: [],

            systemImageStoreDialog: false,
            systemToStoreSystemImage: null,
            systemImageStoring: false,

            systemImageDeleteDialog: false,
            systemToDeleteSystemImage: null,
            systemImageDeleting: false,

            systemImageForm: {
                SystemImage: null,
            },

            systemToAssignClient: null,
            systemAssignClientDialog: false,

            clientID: null,
            clientSearch: null,
            clientIndexing: false,
            clientStoring: false,
            clients: [],

            // pagination
            page: 1,
            lastPage:1,
            from: 0,
            to: 0,
            total: 0,
        };
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.mobile;
        },

        isPageFirst() {
            return this.page === 1;
        },

        isPageLast() {
            return this.page === this.lastPage;
        },

        loadingMessage() {
            return !this.searchQuery
                ? "Pobieranie listy systemów..."
                : "Wyszukiwanie systemów...";
        },

        emptyMessage() {
            return !this.searchQuery
                ? "Brak systemów"
                : "Nie znaleziono systemów pasujących do podanej frazy";
        },
    },
    methods: {
        loadPage() {
            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.load_systems) {
                this.$store.state.sources.load_systems.cancel();
            }

            //Run debouncedFetch
            this.debouncedSystemIndexFast();
        },
        nextPage: function () {
            if (this.page < this.lastPage) {
                this.page++;
                this.loadPage();
            }
        },
        prevPage: function () {
            if (this.page > 1) {
                this.page--;
                this.loadPage();
            }
        },
        resetPage () {
            this.page = 1;
        },
        systemIndex () {
            this.systemIndexing = true;

            this.$store.dispatch('loadSystems', {
                page: this.page,
                searchQuery: this.searchQuery,
                allSystems: 1,
            }).then(response => {
                if(response.status === 200) {
                    this.systems = response.data.data;
                    this.page = response.data.meta.current_page ?? 1;
                    this.lastPage = response.data.meta.last_page ?? 1;
                    this.from = response.data.meta.from ?? 0;
                    this.to = response.data.meta.to ?? 0;
                    this.total = response.data.meta.total;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy systemów.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.systemIndexing = false;
                });
        },
        systemImageStore: function () {
            this.systemImageStoring = true;

            this.$store.dispatch('systemImageStore', {
                SystemID: this.systemToStoreSystemImage.SystemID,
                formData: this.systemImageForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideSystemImageStoreDialog();
                    this.$store.commit("showSnackbarSuccess", "Zapisano zdjęcie.");
                    this.systemIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu zdjęcia.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.systemImageStoring = false;
                });
        },
        systemImageDelete: function (system) {
            this.systemImageDeleting = true;

            this.$store.dispatch('systemImageDelete', system.SystemID).then(response => {
                if (response.status === 204) {
                    this.hideSystemImageDeleteDialog();
                    this.$store.commit("showSnackbarSuccess", "Usunięto zdjęcie.");
                    this.systemIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd usuwania zdjęcia.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.systemImageDeleting = false;
                });
        },
        clientIndex: function () {
            this.clientIndexing = true;

            this.$store.dispatch('clientIndex', {
                search_query: this.clientSearch
            }).then(response => {
                if(response.status === 200) {
                    this.clients = response.data.data;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy klientów.");
                }
            }).catch(error => {})
            .then(() => {
                this.clientIndexing = false;
            });
        },
        clientStore: function () {
            this.clientStoring = true;

            this.$store.dispatch('systemClientStore', {
                System: this.systemToAssignClient,
                ClientID: this.clientID
            }).then(response => {
                if(response.status === 201) {
                    this.hideSystemAssignClientDialog();
                    this.$store.commit("showSnackbarSuccess", "Przypisano Klienta do Systemu.");
                    this.systemIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Nie udało się przypisać Klienta do Systemu.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.clientStoring = false;
                });
        },
        showSystemImageStoreDialog: function (system) {
            this.systemToStoreSystemImage = system;
        },
        hideSystemImageStoreDialog: function () {
            this.systemImageStoreDialog = false;
        },
        showSystemImageDeleteDialog: function (system) {
            this.systemToDeleteSystemImage = system;
        },
        hideSystemImageDeleteDialog: function () {
            this.systemImageDeleteDialog = false;
        },
        resetSystemImageForm: function () {
            for (const index in this.systemImageForm) {
                this.systemImageForm[index] = null;
            }
        },
        showSystemAssignClientDialog: function (system) {
            this.systemToAssignClient = system;
        },
        hideSystemAssignClientDialog: function () {
            this.systemAssignClientDialog = false;
        },
    },
    created() {
        this.debouncedSystemIndex = _.debounce(this.systemIndex, 900);
        this.debouncedSystemIndexFast = _.debounce(this.systemIndex, 300);
        this.debouncedClientIndex = _.debounce(this.clientIndex, 900);

        this.systemIndex();
    },
    watch: {
        searchQuery: function () {
            this.resetPage();

            //If any request_search is currently in progress, cancel it!
            if (this.$store.state.sources.load_systems) {
                this.$store.state.sources.load_systems.cancel();
            }

            //Run debouncedFetch
            this.debouncedSystemIndex();
        },
        systemToStoreSystemImage: function (system) {
            if(system !== null) {
                this.systemImageStoreDialog = true;
            }
        },
        systemImageStoreDialog: function (visible) {
            if(!visible) {
                this.resetSystemImageForm();
                this.$store.commit("resetValidation");
                this.systemToStoreSystemImage = null;
            }
        },
        systemToDeleteSystemImage: function (system) {
            if(system !== null) {
                this.systemImageDeleteDialog = true;
            }
        },
        systemImageDeleteDialog: function (visible) {
            if(!visible) {
                this.systemToDeleteSystemImage = null;
            }
        },
        systemToAssignClient: function (system) {
            if(system !== null) {
                this.systemAssignClientDialog = true;
            }
        },
        systemAssignClientDialog: function (visible) {
            if(!visible) {
                this.$store.commit("resetValidation");
                this.systemToAssignClient = null;
                this.clientID = null;
                this.clientSearch = null;
            }
        },
        clientSearch (value) {
            if(value) {
              this.debouncedClientIndex();
            }
        },
    }
}
</script>

<style scoped>

</style>
